export default __webpack_public_path__ + "static/media/PPSupplyMono-Regular.5bf1cc23.woff";